"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalContent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@escolalms/sdk/lib/react");
var react_2 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var react_i18next_1 = require("react-i18next");
var date_fns_1 = require("date-fns");
var formik_1 = require("formik");
var TaskNote_1 = require("../../TaskNote");
var hi_1 = require("react-icons/hi");
var __1 = require("../../../../");
var RelatedTreeSelect_1 = require("../../../molecules/RelatedTreeSelect");
var common_1 = require("./common");
var Form = styled_components_1.default.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: calc(100% - 50px);\n"], ["\n  display: flex;\n  height: calc(100% - 50px);\n"])));
var ButtonsContainer = (0, styled_components_1.default)(__1.Row)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var PersonalContent = function (_a) {
    var _b;
    var taskForAction = _a.taskForAction, closeModal = _a.closeModal, onStatusUpdateSuccess = _a.onStatusUpdateSuccess, onSuccess = _a.onSuccess, onError = _a.onError;
    var _c = (0, react_2.useState)(false), isStatusUpdating = _c[0], setIsStatusUpdating = _c[1];
    var _d = (0, react_2.useState)(!!taskForAction.completed_at), taskDone = _d[0], setTaskDone = _d[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _e = (0, react_2.useContext)(react_1.EscolaLMSContext), updateTask = _e.updateTask, updateTaskStatus = _e.updateTaskStatus, createTaskNote = _e.createTaskNote, fetchTask = _e.fetchTask, task = _e.task;
    var initialValues = {
        title: taskForAction.title,
        related: taskForAction.related_type && taskForAction.related_id
            ? "".concat(taskForAction.related_type, ":").concat(taskForAction.related_id)
            : undefined,
        description: (_b = taskForAction.description) !== null && _b !== void 0 ? _b : "",
        due_date: taskForAction.due_date,
    };
    (0, react_2.useEffect)(function () {
        fetchTask(taskForAction.id);
    }, [fetchTask, taskForAction.id]);
    return ((0, jsx_runtime_1.jsx)(formik_1.Formik, __assign({ initialValues: initialValues, validate: function (values) {
            var errors = {};
            if (!values.title) {
                errors.title = t("Required");
            }
            if (!values.due_date) {
                errors.due_date = t("Required");
            }
            else if (!(0, date_fns_1.isAfter)(new Date(values.due_date), new Date())) {
                errors.due_date = t("DateAfterToday");
            }
            return errors;
        }, onSubmit: function (_a, _b) {
            var related = _a.related, due_date = _a.due_date, values = __rest(_a, ["related", "due_date"]);
            var setSubmitting = _b.setSubmitting, setErrors = _b.setErrors;
            var sendValues = __assign({}, values);
            if (due_date) {
                sendValues = __assign(__assign({}, sendValues), { due_date: (0, date_fns_1.format)(new Date(due_date), "yyyy-MM-dd") });
            }
            if (related && related.includes(":")) {
                var _c = related.split(":"), related_type = _c[0], related_id = _c[1];
                sendValues = __assign(__assign({}, sendValues), { related_type: related_type, related_id: related_id });
            }
            updateTask(taskForAction.id, sendValues)
                .then(function () {
                values.note && createTaskNote(taskForAction.id, values.note);
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                closeModal();
            })
                .catch(function (err) {
                if (err.data && err.data.errors) {
                    setErrors(Object.keys(values).reduce(function (acc, curr) {
                        var _a;
                        if (err.data.errors[curr]) {
                            return __assign(__assign({}, acc), (_a = {}, _a[curr] = err.data.errors[curr], _a));
                        }
                        return acc;
                    }, {}));
                }
                onError === null || onError === void 0 ? void 0 : onError();
            })
                .finally(function () {
                setSubmitting(false);
            });
        } }, { children: function (_a) {
            var _b;
            var values = _a.values, touched = _a.touched, errors = _a.errors, handleChange = _a.handleChange, handleBlur = _a.handleBlur, handleSubmit = _a.handleSubmit, setFieldValue = _a.setFieldValue;
            return ((0, jsx_runtime_1.jsxs)(Form, __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsxs)(common_1.LeftCol, { children: [(0, jsx_runtime_1.jsxs)(__1.Row, __assign({ "$gap": 16 }, { children: [(0, jsx_runtime_1.jsx)(__1.Checkbox, { disabled: isStatusUpdating, checked: taskDone, onChange: function (e) {
                                            setIsStatusUpdating(true);
                                            updateTaskStatus(taskForAction.id, e.target.checked)
                                                .then(function () {
                                                onStatusUpdateSuccess === null || onStatusUpdateSuccess === void 0 ? void 0 : onStatusUpdateSuccess();
                                                fetchTask(+taskForAction.id);
                                                setIsStatusUpdating(false);
                                                setTaskDone(!taskDone);
                                            })
                                                .catch(function () { return setIsStatusUpdating(false); });
                                        } }), (0, jsx_runtime_1.jsxs)(common_1.SectionHeader, { children: [(0, jsx_runtime_1.jsx)(__1.Input, { label: t("Tasks.Title"), error: touched.title && errors.title ? ((0, jsx_runtime_1.jsx)("p", { children: errors.title })) : undefined, placeholder: t("Tasks.Title"), id: "title", name: "title", value: values.title, onChange: handleChange, onBlur: handleBlur, required: true }), (0, jsx_runtime_1.jsx)(__1.TextArea, { name: "description", id: "description", label: t("Tasks.Description"), placeholder: t("Tasks.Description"), value: values.description, onChange: handleChange }), (0, jsx_runtime_1.jsx)(RelatedTreeSelect_1.RelatedTreeSelect, { label: t("Tasks.RelatesTo"), notFoundContent: t("Tasks.NoContent"), error: touched.related && errors.related
                                                    ? errors.related
                                                    : undefined, id: "related", value: values.related, onChange: function (v) { return setFieldValue("related", v); }, onBlur: handleBlur }), (0, jsx_runtime_1.jsxs)(common_1.NotesContainer, { children: [(0, jsx_runtime_1.jsxs)(__1.Row, __assign({ "$alignItems": "center", "$gap": 4 }, { children: [(0, jsx_runtime_1.jsx)(hi_1.HiOutlineDocumentText, {}), (0, jsx_runtime_1.jsx)(__1.Title, __assign({ level: 5 }, { children: t("Tasks.Notes") }))] })), (0, jsx_runtime_1.jsx)("div", { children: ((_b = task.value) === null || _b === void 0 ? void 0 : _b.notes) && task.value.notes.length > 0 ? (task.value.notes.map(function (note) { return ((0, jsx_runtime_1.jsx)(common_1.Note, { children: (0, jsx_runtime_1.jsx)(TaskNote_1.EditTaskNote, { note: note, onEdit: function () { return fetchTask(taskForAction.id); }, onDelete: function () { return fetchTask(taskForAction.id); } }) }, note.id)); })) : ((0, jsx_runtime_1.jsx)(__1.Text, { children: t("Tasks.NoNotes") })) })] }), (0, jsx_runtime_1.jsx)(TaskNote_1.AddTaskNote, { taskId: taskForAction.id, onSuccess: function () { return fetchTask(taskForAction.id); } })] })] })), (0, jsx_runtime_1.jsxs)(ButtonsContainer, __assign({ "$justifyContent": "flex-end", "$gap": 12 }, { children: [(0, jsx_runtime_1.jsx)(__1.Button, __assign({ mode: "secondary", type: "button", onClick: closeModal }, { children: t("Tasks.Cancel") })), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ mode: "secondary", type: "submit" }, { children: t("Tasks.Save") }))] }))] }), (0, jsx_runtime_1.jsx)(common_1.RightCol, { children: (0, jsx_runtime_1.jsx)(__1.Input, { type: "date", error: touched.due_date && errors.due_date ? ((0, jsx_runtime_1.jsx)("p", { children: errors.due_date })) : undefined, label: t("Tasks.DueDate"), placeholder: t("Tasks.DueDate"), name: "due_date", id: "due_date", onChange: handleChange, onBlur: handleBlur, value: (0, date_fns_1.format)(values.due_date ? new Date(values.due_date) : new Date(), "yyyy-MM-dd") }) })] })));
        } })));
};
exports.PersonalContent = PersonalContent;
var templateObject_1, templateObject_2;
